import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "config.js";
import Conversations from "./Conversation";

export default function ConversationAccess() {
  const [access, setAccess] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    const token = localStorage.getItem("token");
    axios.get(`${API_BASE_URL}/conversations/capabilities`, {
      signal: controller.signal,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }).then(({ data }) => {
      if (!data.success || !data.capabilities) throw new Error("Missing capabilities");
      setAccess(data.capabilities);
    }).catch(() => {
      if (!controller.signal.aborted) setError(true);
    });
    return () => controller.abort();
  }, []);

  if (error) return <div role="alert">Conversation access could not be checked. Please reload to try again.</div>;
  if (!access) return <div role="status">Checking conversation access...</div>;
  if (!access.ui || !access.read) return <div role="status">Conversations is not enabled for this account.</div>;
  return <>{access.sandbox && <div className="alert alert-info" role="status">Synthetic test account: replies and delivery are simulated. Costs use test credits; no real messages or charges occur.</div>}
    <Conversations isPilot={access.pilot === true} canSend={access.send} canMarkRead={access.readOnly !== true} /></>;
}
